<div class="c-page-incomingrequest">
    <div class="container" style="margin-top: 45px;">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a [routerLink]="['/']"> {{'AccessRecordsPortal.home'| translate}} </a></li>
                <li class="breadcrumb-item active" aria-current="page">&nbsp;-<span> {{'AccessRecordsPortal.location'| translate}} </span></li>
            </ol>
        </nav>
        <div class="col-md-12">

            <h2 class="o-title"> {{'AccessRecordsPortal.title'| translate}}</h2>

        </div>
    </div>

    <div class="content-filter">
        <div class="content-filter__group">
            <span></span>
            <input (keyup.enter)="getEmployeeListFilter()" style="background-color: white;" min="0"  [(ngModel)]="requestF" class="o-form__input" type="number" placeholder="{{'AccessRecordsPortal.placeholderNumber'| translate}}" numbersOnly>
            <div *ngIf="isNegative(requestF)" style="width:100%; background-color: #F2F0E9">
                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'AccessRecordsPortal.noNegativeNumber'| translate}}</mat-error></h5></span>
            </div>
        </div>

        <div class="content-filter__group">
            <span></span>
            <select name="typeSelect" (change)="getEmployeeListFilter()" [(ngModel)]="typeF" class="o-form__select" required> 
                <option ngValue='' >{{'AccessRecordsPortal.filterType'| translate}}</option>
                <option [value]='type.id' *ngFor="let type of types">
                    <strong *ngIf="type.id == 1"> {{'AccessRecordsPortal.employee' | translate }} </strong>
                    <strong *ngIf="type.id == 2"> {{'AccessRecordsPortal.contractor' | translate }} </strong>
                    <strong *ngIf="type.id == 3"> {{'AccessRecordsPortal.visitors' | translate }} </strong>
                    <strong *ngIf="type.id == 4"> {{'AccessRecordsPortal.exception' | translate }} </strong>    
                </option>
                <!-- <option ngValue="false"  >{{'AccessRecordsPortal.replacement'| translate}}</option>  {{'AccessRecordsPortal.new'| translate}}-->
              </select>
        </div>
        <div class="content-filter__group">
            <span></span>
            <select name="statusSelect" (change)="getEmployeeListFilter()" [(ngModel)]="statusF" class="o-form__select" required> 
                <option ngValue=''>{{'AccessRecordsPortal.filterStatus'| translate}}</option>
                <option  *ngFor="let status of statusOptions" [ngValue]="status.id"> 
                    <p *ngIf="status.id==1">{{'AccessRecordsPortal.statusPending'| translate}}</p>
                    <p *ngIf="status.id==5">{{'AccessRecordsPortal.statusPendingSarApprover'| translate}}</p>
                    <p *ngIf="status.id==6">{{'AccessRecordsPortal.statusPendingFacility'| translate}}</p>
                    
                    <p *ngIf="status.id==2">{{'AccessRecordsPortal.statusApproved'| translate}}</p>   
                    <p *ngIf="status.id==7">{{'AccessRecordsPortal.statusApprovedSarApprover'| translate}}</p>    
                    <p *ngIf="status.id==8">{{'AccessRecordsPortal.statusApprovedFacility'| translate}}</p>    

                    <p *ngIf="status.id==3">{{'AccessRecordsPortal.statusReject'| translate}}</p>    
                    <p *ngIf="status.id==9">{{'AccessRecordsPortal.statusRejectSarApprover'| translate}}</p>    
                    <p *ngIf="status.id==10">{{'AccessRecordsPortal.statusRejectFacility'| translate}}</p>
                        
                    <p *ngIf="status.id==4">{{'AccessRecordsPortal.statusDelegate'| translate}}</p>    
                    <p *ngIf="status.id==11">{{'AccessRecordsPortal.statusClosed'| translate}}</p>  
                    <p *ngIf="status.id==12">{{'AccessRecordsPortal.pending-visitors'| translate}}</p>  
                    <p *ngIf="status.id==13">{{'AccessRecordsPortal.terminated-visitor'| translate}}</p>       
                </option>
            
              </select>
        </div>

        <div class="content-filter__group">
            <div slign="center">
                <mat-form-field>
                    <mat-label>{{'AccessRecordsPortal.filterDateStart'| translate}}</mat-label>
                    <input matInput #resultPickerModel="ngModel" [max]="maxDate" [matDatepicker]="picker" [(ngModel)]="dateSelectStart" value="date">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="resultPickerModel.hasError('matDatepickerParse')">
                        "{{resultPickerModel.getError('matDatepickerParse').text}}" {{'AccessRecordsPortal.validDate'| translate}}
                    </mat-error>
                    <mat-error *ngIf="resultPickerModel.hasError('matDatepickerMax')">{{'AccessRecordsPortal.minDate'| translate}}</mat-error>
                </mat-form-field>

                <div slign="center">
                    <mat-form-field>
                        <mat-label>{{'AccessRecordsPortal.filterDateEnd'| translate}}</mat-label>
                        <input matInput #resultPickerModel2="ngModel" [min]="dateSelectStart" [max]="maxDate" [matDatepicker]="picker2" [(ngModel)]="dateSelectEnd" value="date">
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                        <mat-error *ngIf="resultPickerModel2.hasError('matDatepickerParse')">
                            "{{resultPickerModel2.getError('matDatepickerParse').text}}" {{'AccessRecordsPortal.validDate'| translate}}
                        </mat-error>
                    </mat-form-field>
                </div>

            </div>
        </div>
    </div>

    <div class="container u-pb30">
        <div class="row mobile--orange u-pt40">

        </div>
        <div class="row">
            <div class="col-md-12">
                <!-- <div class="c-search"> -->
                <!-- </div> -->
                <div class="filters">
                    <button class="btn btn--primary open_modal" (click)="clearFilter()" (click)="resultPickerModel.reset()" (click)="resultPickerModel2.reset()" mat-raised-button>{{'AccessRecordsPortal.btnClearFilter'| translate}}</button>
                    <button class="btn btn--primary open_modal" [disabled]="isNegative(requestF)" (click)="getEmployeeListFilter()" mat-raised-button>{{'AccessRecordsPortal.btnApplyFilter'| translate}}</button>
                </div>

                <table class="table table-bordered table-striped table-condensed">
                    <thead>
                        <tr>
                            <th>
                                <p><a (click)="orderby('requestNumber', requestDesc)"><span >{{'AccessRecordsPortal.colReqNumber' | translate}}</span>
                                         <i *ngIf="!requestDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i> 
                                        <i *ngIf="requestDesc" style="cursor: pointer; transform: rotate(90deg);;" class="icon icon-arrow "></i> 
                                        </a>
                                </p>
                            </th>
                            <th>
                                <p> <a (click)="orderby('type',typeDesc )"><span>{{'AccessRecordsPortal.colType' | translate}}</span>

                                        <i *ngIf="!typeDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i> 
                                        <i *ngIf="typeDesc" style="cursor: pointer; transform: rotate(90deg);;" class="icon icon-arrow "></i>  
                                        </a>
                                </p>

                            </th>
                            <th>
                                <p><a (click)="orderby('status', statusDesc)"><span >{{'AccessRecordsPortal.colStatus' | translate}}</span>
                                        <i *ngIf="!statusDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i> 
                                        <i *ngIf="statusDesc" style="cursor: pointer; transform: rotate(90deg);;" class="icon icon-arrow "></i>
                                        </a>
                                </p>
                            </th>
                            <th>
                                <p><a (click)="orderby('requesterId', requestorDesc)"><span > {{'AccessRecordsPortal.colRequestor' | translate}}</span>
                                        <i *ngIf="!requestorDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i> 
                                        <i *ngIf="requestorDesc" style="cursor: pointer; transform: rotate(90deg);;" class="icon icon-arrow "></i>
                                        </a>
                                </p>
                            </th>

                            <th>
                                <p><a (click)="orderby('requestDate', requestDateDesc)"><span > {{'AccessRecordsPortal.colReqDate' | translate}}</span>
                                        <i *ngIf="!requestDateDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i> 
                                        <i *ngIf="requestDateDesc" style="cursor: pointer; transform: rotate(90deg);" class="icon icon-arrow "></i>
                                        </a>
                                </p>
                            </th>
                            <th>
                                <p><a><span > {{'AccessRecordsPortal.colDetails' | translate}}</span>
                                       
                                        </a>
                                </p>
                            </th>

                        </tr>
                    </thead>
                    <tbody>

                        <tr *ngFor="let item of SeeItems">
                            <td style="text-align: center;">
                                <p>
                                    <strong>
                                            {{item.requestNumber}}
                                        </strong>
                                </p>
                            </td>
                            <td class="table__title-row">
                                <p>
                                    <!-- <strong>{{item.type.Name | titlecase}}</strong> -->

                                    <strong *ngIf="item.type.Id == 1"> {{'AccessRecordsPortal.employee' | translate }} </strong>
                                    <strong *ngIf="item.type.Id == 2"> {{'AccessRecordsPortal.contractor' | translate }} </strong>
                                    <strong *ngIf="item.type.Id == 3"> {{'AccessRecordsPortal.visitors' | translate }} </strong>
                                    <strong *ngIf="item.type.Id == 4"> {{'AccessRecordsPortal.exception' | translate }} </strong>
                                    <!-- <strong *ngIf="item.type==true"> {{'AccessRecordsPortal.new'| translate}} </strong>
                                        <strong *ngIf="item.type==false"> {{'AccessRecordsPortal.replacement'| translate}} </strong> -->
                                </p>
                            </td>

                            <td>

                                <i *ngIf="item.status.Id==1 || item.status.Id==6 || item.status.Id==5 || item.status.Id==12" class="icon icon-more"> </i>
                                <i *ngIf="item.status.Id==11 ||item.status.Id==3 || item.status.Id==10 || item.status.Id==9|| item.status.Id==13" class="icon icon-close"> </i>
                                <i *ngIf="item.status.Id==2 || item.status.Id==8 || item.status.Id==7" class="icon icon-check"> </i>
                                <i *ngIf="item.status.Id==4" class="icon icon-arrow" style=" transform: rotateY(180deg);">  </i>

                                <span *ngIf="item.status.Id==6">{{'AccessRecordsPortal.statusPendingFacility'| translate}} </span>
                                <span *ngIf="item.status.Id==5">{{'AccessRecordsPortal.statusPendingSarApprover'| translate}}</span>
                                <span *ngIf="item.status.Id==1">{{'AccessRecordsPortal.statusPending'| translate}} </span>

                                <span *ngIf="item.status.Id==3">{{'AccessRecordsPortal.statusReject'| translate}} </span>
                                <span *ngIf="item.status.Id==10">{{'AccessRecordsPortal.statusRejectFacility'| translate}}</span>
                                <span *ngIf="item.status.Id==9">{{'AccessRecordsPortal.statusRejectSarApprover'| translate}}</span>


                                <span *ngIf="item.status.Id==2">{{'AccessRecordsPortal.statusApproved'| translate}} </span>
                                <span *ngIf="item.status.Id==8">{{'AccessRecordsPortal.statusApprovedFacility'| translate}} </span>
                                <span *ngIf="item.status.Id==7">{{'AccessRecordsPortal.statusApprovedSarApprover'| translate}} </span>

                                <span *ngIf="item.status.Id==4">&nbsp; {{'AccessRecordsPortal.statusDelegate'| translate}} </span>
                                <span *ngIf="item.status.Id==11"> {{'AccessRecordsPortal.statusClosed'| translate}} </span>

                                <span *ngIf="item.status.Id==12">{{'AccessRecordsPortal.pending-visitors'| translate}}</span>
                                <span *ngIf="item.status.Id==13">{{'AccessRecordsPortal.terminated-visitor'| translate}} </span>

                            </td>

                            <td style="text-align: center;">
                                <p> <strong> {{ item.requestorName }}  </strong> </p>
                            </td>
                            <td>
                                <p> <strong> {{ item.createdAt | date: 'dd/MM/yyyy'  }}  </strong> </p>
                            </td>

                            <td>
                                <div align="center">
                                    <p>
                                        <span class="table__mobile">{{'AccessRecordsPortal.colDetails' | translate}}: </span>
                                        <a [routerLink]="['/access-list/records/', item.requestNumber ]">
                                            <img src="../assets/img/icn/ICONO/ARCHIVO.svg" alt="" title="{{'AccessRecordsPortal.msgSeeDetails'| translate}}">
                                        </a>
                                    </p>
                                </div>
                            </td>
                        </tr>

                    </tbody>
                </table>

            </div>
            <div class="col-md-12">
                <hr class="big">
                <div class="row pagination-main">
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-6">
                        <ul class="pagination">

                            <mat-paginator #paginator [length]="totalItems" [pageSize]="pageSize" (page)="handlePage($event)" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>